import { render, staticRenderFns } from "./StatisticsProcessTime.vue?vue&type=template&id=902ffd24&scoped=true"
import script from "./StatisticsProcessTime.vue?vue&type=script&lang=js"
export * from "./StatisticsProcessTime.vue?vue&type=script&lang=js"
import style0 from "./StatisticsProcessTime.vue?vue&type=style&index=0&id=902ffd24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902ffd24",
  null
  
)

export default component.exports